import sagaMiddleware from './sagaMiddleware';
// middlewares
const middlewares = [sagaMiddleware];

export default middlewares;
